/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Account_Notsignedin2Inputs */

const he_extension_popup_account_notsignedin2 = /** @type {(inputs: Extension_Popup_Account_Notsignedin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא מחובר`)
};

const en_extension_popup_account_notsignedin2 = /** @type {(inputs: Extension_Popup_Account_Notsignedin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not signed in`)
};

/**
* | output |
* | --- |
* | "Not signed in" |
*
* @param {Extension_Popup_Account_Notsignedin2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_account_notsignedin2 = /** @type {((inputs?: Extension_Popup_Account_Notsignedin2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Account_Notsignedin2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_account_notsignedin2(inputs)
	return en_extension_popup_account_notsignedin2(inputs)
});
export { extension_popup_account_notsignedin2 as "extension_popup_account_notSignedIn" }